import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ChapterType } from 'libraries/service/resources/quotation-quotations/IQuotationsQuotation';

@Component({
    selector: 'td-separator',
    template: `
        <ng-template #template>
            <td class="separator"
                [class.is-trip]="isTrip"
                [class.is-land]="isTrip && isLand"
                [attr.rowspan]="blocksNumberInSection"></td>
        </ng-template>
    `,
    styles: [`
        :host {
            display: none
        }

        .separator {
            background: #f1f1f1;
            width: 10px;
            min-width: 10px;
            position: sticky;
            left: 0;
            z-index: 1;
            border-right: 1px solid white;
            border-bottom: 1px solid white;
        }

        .is-trip {
            background: #337ab7;
        }

        .is-land {
            background: darkgrey;
        }
    `],
})

export class TdSeparatorComponent implements OnInit {

    @Input()
    public blocksNumberInSection: number = 1;

    @Input()
    public isTrip: boolean;

    @Input()
    public isLand: boolean = true;

    @Input()
    public chapterCode: ChapterType;

    @ViewChild('template', {read: TemplateRef, static: true})
    public template: TemplateRef<{}>;

    constructor(
        private viewContainerRef: ViewContainerRef
    ) {
    }

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);
    }
}
